import React from 'react'
import "./materialdocuments.css"
const documentItems = [
  { id: 1, particular: "Memorandum of Association" },
  { id: 2, particular: "Articles of Association" },
  { id: 3, particular: "Certificate of Incorporation" },
  { id: 4, particular: "COI of Conversion" },
  { id: 5, particular: "Board Resolution IPO" },
  { id: 6, particular: "Special Resolution IPO" },
  { id: 7, particular: "Consent" },
  { id: 8, particular: "Tax Benefit Certificate Peer Review" },
  
  { id: 9, particular: "Key Performance Indicator Certificate" },
  { id: 10, particular: "BR_ DRHP" },
  { id: 11, particular: "BR_RHP" },
  { id: 12, particular: "DD Certificate" },
  { id: 13, particular: "Inprinciple Approval" },

];

const materialItems = [
    { id: 1, particular: "Issuer Agreement" },   
    { id: 2, particular: "RTA Agreement" },   
    { id: 3, particular: "Banker to the issue Agreement" },   
    { id: 4, particular: "Market Maker Agreement" },   
    { id: 5, particular: "Underwriting Agreement" },   
    { id: 6, particular: "Syndicate Agreement" },   
    { id: 7, particular: "Monitoring Agency Agreement" },   
    { id: 8, particular: "NSDL OR CDSL Agreement" },   

]

const MaterialDocuments = () => {
  return (
    <div className="main-container">
      {/* Hero Section — same structure as Career hero */}
      <section className="Career-hero-section">
        <div className="Career-heading">
          <h2> Material Documents / Contracts</h2>
        </div>
      </section>
      <section className="disclosure-section">
      <div className="disclosure-container">
        {/* <h1 className="disclosure-title">Regulation 46 of SEBI (LODR) 2015: Website Disclosure</h1> */}

        <div className="disclosure-table-wrapper">
          <table className="disclosure-table">
            <thead>
              <tr>
                <th className="col-sl">Sr. No.</th>
                <th className="col-particular">Material Documents</th>
              </tr>
            </thead>
            <tbody>
              {documentItems.map((item, index) => (
                <tr key={item.id} className={index % 2 === 0 ? "row-even" : "row-odd"}>
                  <td className="col-sl">{item.id}.</td>
                  <td className="col-particular">{item.particular}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        <br />
        <div className="disclosure-table-wrapper">
          <table className="disclosure-table">
            <thead>
              <tr>
                <th className="col-sl">Sr. No.</th>
                <th className="col-particular">Material Contracts</th>
              </tr>
            </thead>
            <tbody>
              {materialItems.map((item, index) => (
                <tr key={item.id} className={index % 2 === 0 ? "row-even" : "row-odd"}>
                  <td className="col-sl">{item.id}.</td>
                  <td className="col-particular">{item.particular}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
    </div>
  )
}

export default MaterialDocuments